import { GridStateSnapshot } from 'react-virtuoso';
import { create } from 'zustand';

type UseMediaKitsGridState = {
  state?: GridStateSnapshot;
  setState: (d: UseMediaKitsGridState['state']) => void;
};

export const useMediaKitsGridState = create<UseMediaKitsGridState>((set) => ({
  state: undefined,
  setState: (d) => set({ state: d }),
}));
